<template>
  <div>

    <h2 class="text-black">Você já faz parte <br> do gusmao-labrunie Carreiras!</h2>
    <p class="h5 font-weight-normal mb-5">Seu CPF foi encontrado em nosso parceiro <strong>99jobs.com</strong>. Você pode fazer o login com o mesmo usuário e senha! Retorne à área de Login para acessar sua conta. :)</p>

    <button class="btn btn-white d-flex align-items-center text-left border border-light-dark p-3 mx-auto" style="max-width: 320px;" @click="$emit('changeModal', 'login')">
      <img v-if="$store.state.deviseTrying.avatar" :src="$store.state.deviseTrying.avatar">
      <account-circle-icon v-else class="img text-blue-ml" />
      <div class="ml-3">
        <h5 class="m-0">{{ $store.state.deviseTrying.name }}</h5>
        <p class="m-0">E-mail: {{ $helpers.censorEmail($store.state.deviseTrying.email) }}</p>
      </div>
    </button>

    <button class="btn btn-link d-flex align-items-center text-left p-0 mx-auto" @click.prevent="$emit('changeModal', 'forgotUser')">
      Não tenho acesso a esse e-mail
    </button>

    <div class="text-center mt-5">
      <button type="submit" class="btn btn-blue-ml px-4" @click="$emit('changeModal', 'login')">Voltar para Login</button>
    </div>

  </div>
</template>

<script>
  import AccountCircleIcon from "vue-material-design-icons/AccountCircle.vue";

  export default {
    name: 'UserExists',

    data(){
      return {
        cpf: ''
      }
    },

    components: {
      AccountCircleIcon
    },

    computed: {
    },

    methods: {
      hasNoAccess(){
        this.$swal({
          title: 'Não tem acesso a esse e-mail?',
          html: '<p>Envie um e-mail para <a href="mailto:suporte@99jobs.com">suporte@99jobs.com</a> informando seu: <b>CPF</b>, <b>e-mail cadastrado</b> e o <b>e-mail que deseja utilizar</b> para que nossa equipe de suporte possa te ajudar.</p>',
          type: 'info'
        }).then(() => this.$emit('changeModal', 'login'));
      }
    }
  }
</script>

<style lang="scss" scoped>
  img{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
  }

  .img{
    font-size: 50px;
  }
</style>